import { withChakraTheme } from './withChakraTheme';
import { withI18nProvider } from './withI18nProvider';
export const withBeProviders = (Component) => withChakraTheme(withI18nProvider(Component));
